export const PENDING_SUCCESS_NOTICE_TTL_MS = 15000;

interface PendingNotice {
    messageKey: string;
    markedAt: number;
}

let pendingNotice: PendingNotice | null = null;

export function markPendingSuccessNotice(messageKey: string, now: number = Date.now()): void {
    pendingNotice = { messageKey, markedAt: now };
}

export function takePendingSuccessNotice(now: number = Date.now()): string | null {
    const notice = pendingNotice;
    pendingNotice = null;

    if (notice == null) return null;
    return (now - notice.markedAt <= PENDING_SUCCESS_NOTICE_TTL_MS) ? notice.messageKey : null;
}

export function clearPendingSuccessNotice(): void {
    pendingNotice = null;
}
